import React from 'react';
import { useWidget } from 'components/Widget/useWidget';
import MetricsList from './MetricsList';
import ChartOptions from './ChartOption';

const Design = () => {
  const widget = useWidget();

  return (
    <div className='my-4 grid gap-2'>
      <ChartOptions widget={widget} />
      <MetricsList widget={widget} />
    </div>
  );
};

export default Design;
